export { default } from './ProductImagesModal'
